import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

/**
 * Captcha component
 * @param {*} props
 */
const Captcha = (props) => {
    const { meta: { touched, error } } = props;
    return (
        <div>
            <ReCAPTCHA
                sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                onChange={props.input.onChange}
            />
            <span className="input-error">{touched ? error : ''}</span>
        </div>
    );
};

export default Captcha;
